import { Countries } from './countries'

export const Languages = {
  SWEDISH: 'sv',
  NORWEGIAN: 'nb',
  DANISH: 'da',
  FINNISH: 'fi',
}

export const getDefaultCountry = lang => {
  switch (lang.toLowerCase()) {
    case Languages.FINNISH:
    case 'finnish':
      return Countries.FI
    case Languages.DANISH:
    case 'danish':
      return Countries.DK
    case Languages.NORWEGIAN:
    case 'norwegian':
      return Countries.NO
    case Languages.SWEDISH:
    case 'swedish':
    default:
      return Countries.SE
  }
}

export const getDefaultForCountry = country => {
  switch (country) {
    case Countries.DK:
      return Languages.DANISH
    case Countries.NO:
      return Languages.NORWEGIAN
    case Countries.FI:
      return Languages.FINNISH
    case Countries.SE:
    default:
      return Languages.SWEDISH
  }
}
